const Manual = () => {
  return (
    <iframe
      src={`${process.env.PUBLIC_URL}/manual/index.html`}
      title="Manual WMS"
      allow="fullscreen"
      style={{
        display: "block",
        width: "100%",
        height: "100vh",
        border: 0,
      }}
    />
  );
};

export default Manual;
